import React, { useState } from 'react';


export function useExecution(functionHandler, loadingInitial = false, errorInitial = null) {
    const [loading, setLoading] = useState(loadingInitial);
    const [error, setError] = useState(errorInitial);

    const execute = async (...args) => {
        setLoading(true);
        setError(null);
        try {
            return await functionHandler(...args);
        } catch (e) {
            setError(e.message || true);
            throw e;
        } finally {
            setLoading(false);
        }
    }

    return {
        loading: loading,
        error: error,
        execute: execute
    }
}